import { render, staticRenderFns } from "./add.vue?vue&type=template&id=48ae18a2"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=48ae18a2&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\lptni\\开发\\dev\\project\\unbox-server\\vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48ae18a2')) {
      api.createRecord('48ae18a2', component.options)
    } else {
      api.reload('48ae18a2', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=48ae18a2", function () {
      api.rerender('48ae18a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/offlineblindDataOrder/edit/add.vue"
export default component.exports